<template>
  <div class="h-full w-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-full h-full overflow-hidden">
      <gallery-grid
        :multimedia="listGalleryMultimedia"
        :colorP="color_principal"
        :colorS="color_secundario"
        :colorT="color_terciario"
      ></gallery-grid>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GalleryGrid from "./GalleryGrid";

// Nombre de días...
const weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
const month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

export default {
  name: "Gallery",
  data: function () {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      category: window.atob(localStorage.getItem("category")),
      email: localStorage.getItem("email"),
      listGalleryMultimedia: [],
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
    };
  },
  components: {
    GalleryGrid,
  },
  mounted() {
    this.getLevantamientos();
  },
  methods: {
    getLevantamientos: function () {
      axios
        .post(
          "apidev/levantamientos/getAllLevantamientos",
          {
            category: this.category,
            email: this.email,
          },
          this.config
        )
        .then((response) => {
          let listaLevantamientos = response.data.levantamientos;

          listaLevantamientos.forEach((levantamiento) => {
            if (levantamiento.media_array !== null) {
              let multimediaArray = JSON.parse(levantamiento.media_array);
              multimediaArray.forEach((multimedia) => {
                //if (multimediaArray.length > 0) {
                multimedia.usuario_id = levantamiento.usuario_id;
                multimedia.nombre = levantamiento.nombre;
                multimedia.nombre_usuario = levantamiento.nombre_usuario;
                multimedia.apellido_usuario = levantamiento.apellido_usuario;
                let TDate = new Date(levantamiento.fecha_levantamiento);
                TDate =
                  weekday[TDate.getDay()] +
                  " " +
                  TDate.getDate() +
                  " de " +
                  month[TDate.getMonth()] +
                  " de " +
                  TDate.getFullYear();
                multimedia.TDate = TDate;
                multimedia.id = levantamiento.id;
                multimedia.latitud = levantamiento.latitud;
                multimedia.longitud = levantamiento.longitud;
                this.listGalleryMultimedia.push(multimedia);
                //}
              });
            }
          });
        })
        .catch((error) => {
          // removed console log
        });
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>
